import React from 'react';

const SvgKy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="KY_svg__d">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F0F0F0" offset="100%" />
      </linearGradient>
      <path
        d="M0 4.667V0h6.667v4.667c0 3.333-3.334 4.666-3.334 4.666S0 8 0 4.667z"
        id="KY_svg__c"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KY_svg__b" fill="#fff">
        <use xlinkHref="#KY_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#KY_svg__a" />
      <path fill="#07319C" mask="url(#KY_svg__b)" d="M0 0h28v20H0z" />
      <ellipse
        fill="#FAD051"
        mask="url(#KY_svg__b)"
        cx={20.667}
        cy={5.333}
        rx={2}
        ry={1.333}
      />
      <g mask="url(#KY_svg__b)">
        <g transform="translate(17.333 5.333)">
          <mask id="KY_svg__e" fill="#fff">
            <use xlinkHref="#KY_svg__c" />
          </mask>
          <use fill="url(#KY_svg__d)" xlinkHref="#KY_svg__c" />
          <path fill="#CF142C" mask="url(#KY_svg__e)" d="M0 0h6.667v1.333H0z" />
          <path
            d="M0 8h6.667v1.333H0V8zm0-2.667h6.667v1.334H0V5.333zm0-2.666h6.667V4H0V2.667z"
            fill="#125FBA"
            mask="url(#KY_svg__e)"
          />
        </g>
      </g>
      <path
        d="M4.333 4.153L-.9-.333H.667l.193.062L5.44 3h1.131l5.762-3.601v.934c0 .296-.17.627-.417.803l-4.25 3.036V5.18l4.3 3.685c.377.323.185.802-.3.802-.257 0-.588-.107-.804-.261L6.56 6.333H5.429L-.333 9.935v-1.44l4.666-3.333V4.153z"
        stroke="#FFF"
        strokeWidth={0.667}
        fill="#DB1E36"
        mask="url(#KY_svg__b)"
      />
      <path
        d="M0 3.333V6h4.667v3.34c0 .364.306.66.673.66h1.32a.67.67 0 0 0 .673-.66V6h4.658a.677.677 0 0 0 .676-.673v-1.32a.674.674 0 0 0-.676-.674H7.333V0H4.667v3.333H0z"
        fill="#FFF"
        mask="url(#KY_svg__b)"
      />
      <path
        fill="#DB1E36"
        mask="url(#KY_svg__b)"
        d="M0 4h5.333V0h1.334v4H12v1.333H6.667v4H5.333v-4H0z"
      />
    </g>
  </svg>
);

export default SvgKy;
